export default __webpack_public_path__ + "static/media/Icon9.5a3dfb2f.png";